import React, { useState } from "react";
import "./question.css";
import parse from "html-react-parser";
import user_image from "../../../../assets/images/mobile_emoji/lady.jpg";
import { Modal, Box, Typography, IconButton } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Close } from "@mui/icons-material";

const useModalStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "16px",
    [theme.breakpoints.down("sm")]: {
      padding: "4px !important",
      paddingTop: "20px !important",
    },
  },
  modalContent: {
    backgroundColor: "#ffffff !important",
    borderRadius: "8px !important",
    padding: "20px !important",
    maxWidth: "500px",
    width: "90%",
    maxHeight: "80vh",
    overflow: "hidden",
    outline: "none",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15) !important",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("sm")]: {
      padding: "12px !important",
      width: "95% !important",
      maxHeight: "85vh !important",
      borderRadius: "8px !important",
    },
  },
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "16px !important",
    borderBottom: "1px solid #e2e8f0",
    paddingBottom: "12px !important",
    flexShrink: 0,
    [theme.breakpoints.down("sm")]: {
      marginBottom: "10px !important",
      paddingBottom: "8px !important",
    },
  },
  modalTitle: {
    fontFamily: "Inter, sans-serif !important",
    fontSize: "18px !important",
    fontWeight: "600 !important",
    color: "#334155 !important",
    flex: 1,
    marginRight: "8px !important",
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px !important",
      fontWeight: "700 !important",
    },
  },
  modalBody: {
    fontFamily: "Inter, sans-serif !important",
    fontSize: "14px !important",
    color: "#475569 !important",
    lineHeight: "1.6 !important",
    overflow: "auto",
    flex: 1,
    "& p": {
      marginBottom: "8px !important",
      wordWrap: "break-word !important",
    },
    "& img": {
      maxWidth: "100% !important",
      height: "auto !important",
      borderRadius: "4px !important",
      marginBottom: "8px !important",
      display: "block !important",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "13px !important",
      lineHeight: "1.5 !important",
      "& img": {
        maxHeight: "200px !important",
        objectFit: "cover !important",
        width: "100% !important",
      },
    },
  },
}));

function SingleQuestion({ question, survey_theme, ...props }) {
  const [showGuidance, setShowGuidance] = useState(false);
  const modalClasses = useModalStyles();

  const handleModalOpen = () => {
    setShowGuidance(true);
  };

  const handleModalClose = () => {
    setShowGuidance(false);
  };

  return (
    <>
      <div className="flex items-end justify-start pr-8 transition-all duration-200 m-t-30">
        <div className="flex-shrink-0 w-8 h-8 overflow-hidden rounded-full">
          <img
            className="object-cover w-full h-full"
            src={user_image}
            alt="user_demo"
          />
        </div>
        <div
          className="ms-2 text-white rounded-bl-none rounded-2xl"
          style={{ backgroundColor: survey_theme?.primaryColor }}
        >
          <div
            style={{
              padding: "0.60rem 1rem",
            }}
          >
            <span className="leading-tight">
              {question?.text ? parse(question?.text) : ""}
            </span>
            {question?.questionGuidance ? (
              <>
                <i
                  className="fa fa-info-circle ms-1"
                  style={{ cursor: "pointer" }}
                  onClick={handleModalOpen}
                ></i>
                <Modal
                  open={showGuidance}
                  onClose={handleModalClose}
                  className={modalClasses.modal}
                >
                  <Box className={modalClasses.modalContent}>
                    <Box className={modalClasses.modalHeader}>
                      <Typography className={modalClasses.modalTitle}>
                        Question Guidance
                      </Typography>
                      <IconButton
                        onClick={handleModalClose}
                        size="small"
                        style={{
                          color: "#64748b",
                          padding: "8px",
                          minWidth: "40px",
                          minHeight: "40px",
                        }}
                      >
                        <Close />
                      </IconButton>
                    </Box>
                    <Box className={modalClasses.modalBody}>
                      {question?.questionGuidance
                        ? parse(question?.questionGuidance)
                        : ""}
                      {question?.questionGuidanceImages?.length ? (
                        <div>
                          {question?.questionGuidanceImages?.map((image) => (
                            <img src={image} alt="question" />
                          ))}
                        </div>
                      ) : null}
                    </Box>
                  </Box>
                </Modal>
              </>
            ) : null}
            {question?.unit ? (
              <span className="ms-1">({question.unit})</span>
            ) : null}
          </div>
        </div>
      </div>
      {question?.images?.length ? (
        <div className="mt-2 answerImage">
          {question.images?.map((image, index) => (
            <div key={index}>
              <img src={image} alt={`file-${index}`} />
            </div>
          ))}
        </div>
      ) : null}
    </>
  );
}

export default SingleQuestion;
